import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Hub } from 'aws-amplify/utils';
import { fetchAuthSession } from 'aws-amplify/auth';

export function CallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Try to resolve the session immediately (covers the case where
    // Amplify has already exchanged the auth code by the time this mounts)
    async function tryRedirect() {
      try {
        const session = await fetchAuthSession();
        if (session.tokens) {
          navigate('/', { replace: true });
          return;
        }
      } catch {
        // not ready yet — wait for Hub event
      }
    }

    tryRedirect();

    // Listen for the Amplify auth signInWithRedirect event
    const unsubscribe = Hub.listen('auth', ({ payload }) => {
      if (payload.event === 'signInWithRedirect') {
        navigate('/', { replace: true });
      }
      if (payload.event === 'signInWithRedirect_failure') {
        navigate('/login', { replace: true });
      }
    });

    return unsubscribe;
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100">
      <div className="text-slate-500 text-sm">Completing sign in...</div>
    </div>
  );
}
